import { put, takeLatest, all, call, fork } from "redux-saga/effects";
import { machineCatalogueActions } from "../../constants/actionTypes";
import {
  setSkusListData,
  setSkusListError,
  setCatalogCreateSuccess,
  setCatalogCreateError,
  setCatalogEditSuccess,
  setCatalogEditError,
  catalogueBulkUploadSuccess,
  catalogueBulkUploadError,
  removeSkuSuccess,
  removeSkuError,
  addSkuSuccess,
  addSkuError,
  retireSkuSuccess,
  retireSkuError,
  commonLoaderSuccess,
  setCloudTemplateById,
  setCloudTemplateByIdError,
  getCloudBatchesError,
  getCloudBatchesSuccess,
  getCloudLabSuccess,
  getCloudLabError,
  getCloudBatchByIdSuccess,
  getCloudBatchByIdError,
  getCloudLabByIdSuccess,
  getCloudLabByIdError,
  createCloudBatchSuccess,
  createCloudBatchError,
  setBatchLoading,
  setBatchDetailsLoading,
  getCloudBatches,
  deleteCloudBatchSuccess,
  deleteCloudBatchError,
  getCloudLabs,
  setTemplateDetailsLoading,
  setLabLoading,
  setLabDetailsLoading,
  createCloudLabSuccess,
  createCloudLabError,
  getCloudBatchById,
  createCloudLabExtensionSuccess,
  createCloudLabExtensionError,
  deleteCloudTemplateByIdSuccess,
  setLinkTenantListLoading,
  getLinkTenantListSuccess,
  setLinkTenantLoading,
  createLinkedTenantSuccess,
  deleteLinkedTenantSuccess,
  retrieveByIdLinkedTenantSuccess,
  successCloudLabCredential,
  errorCloudLabCredential,
  createLinkedTenantError,
  deleteCloudLabSuccess,
  deleteCloudTemplateByIdError,
  setCloudCred,
  setCloudLabReProvisionSuccess,
  setCloudLabReProvisionError,
  setUpdatePermissionPolicySuccess,
  setUpdatePermissionPolicyError,
  getWorkspaceCloudBatchByIdError,
  getWorkspaceCloudBatchByIdSuccess,
  resetCloudBatchList,
  resetWorkspaceCloudBatchesReports,
  setWorkspaceCloudBatchesReportsSuccess,
  setWorkspaceCloudBatchesReportsError,
  setWorkspacesTenantList,
  resetWorkspaceBatchReportForm,
  setWorkspacesByTenantIdSuccess,
  generateWorkspaceReportSuccess,
  generateWorkspaceReportError,
  azureReportDownloadLoading,
  azureReportDownloadError,
  azureReportDownloadSuccess,
  cleanUpAzureLoading,
  cleanUpAzureSuccess,
  cleanUpAzureError,
  syncBillSuccess,
  syncBillError,
  aws_cleanup_loading,
  aws_cleanup_success,
  aws_cleanup_error,
  getMentorListSuccess,
  getMentorListFail,
} from "../actions";
import {
  fetchSkusList,
  createCatalogApi,
  editCatalogApi,
  catalogBulkUploadApi,
  removeSkuApi,
  addSkuApi,
  retireSkuApi,
  azureReportDownloadApi,
  cleanUpAzureApi,
  syncBillApi,
  awsCleanupApi,
  getMentorListApi,
} from "../api/machineCatalogue";
import { deletePublicCloudTemplateRequest } from "../api/resourceManager";
import { statusCode } from "../../constants/apis/apiStatus";
import { toastNotification } from "../../utils/toast";
import { errorMessage, toasterFlags } from "../../constants/componentConstants";
import {
  createCloudBatchExtensionRequest,
  createCloudBatchRequest,
  createCloudLabExtensionRequest,
  createCloudLabRequest,
  deleteCloudBatchRequest,
  deleteCloudLabRequest,
  retrieveCloudLabAwsRequest,
  getCloudTemplateByIdRequest,
  listCloudBatchRequest,
  listCloudLabRequest,
  patchCloudBatchRequest,
  retrieveCloudBatchByIdRequest,
  retrieveCloudWorkspaceBatchByIdRequest,
  updateCloudBatchRequest,
  getCloudLabByIdRequest,
  listCloudTemplateTenantRequest,
  createCloudTemplateTenantRequest,
  deleteCloudTemplateTenantRequest,
  updateCloudTemplateTenantRequest,
  retrieveByIdCloudTemplateTenantRequest,
  retrieveCloudLabCredential,
  cloudLabReProvisionRequest,
  updatePermissionPolicyRequest,
  workspaceCloudBatchReportsListApi,
  workspaceBatchTenantListApi,
  generateWorkspaceReportApi,
} from "../api/machineCatalog";
import { appendParam } from "../../utils";

export function* fetchSkusListFunction({ payload }) {
  try {
    const data = yield call(fetchSkusList, payload);
    if (
      data?.status === statusCode.Ok200 ||
      data?.status === statusCode.Created201
    ) {
      yield put(setSkusListData(data));
    } else {
      data?.response
        ? yield put(setSkusListError(data))
        : yield put(setSkusListError({ response: data?.data?.message }));
    }
    if (data?.data?.error && data?.data?.message) {
      toastNotification(toasterFlags.ERROR, data?.data?.message);
    }
  } catch (err) {
    console.log(err);
    yield put(setSkusListError(err));
  }
}

export function* createCatalogFunction({ payload }) {
  try {
    const data = yield call(createCatalogApi, payload);
    if (
      data?.status === statusCode.Ok200 ||
      data?.status === statusCode.Created201
    ) {
      yield put(setCatalogCreateSuccess(data));
    } else {
      yield put(setCatalogCreateError(data));
    }
  } catch (err) {
    yield put(setCatalogCreateError(err));
  }
}

export function* editCatalogFunction({ payload }) {
  try {
    const data = yield call(editCatalogApi, payload);
    if (
      data?.status === statusCode.Ok200 ||
      data?.status === statusCode.Created201
    ) {
      if (payload?.toDestroy) {
        toastNotification(toasterFlags.SUCCESS, data?.data?.Success);
      } else {
        yield put(setCatalogEditSuccess(data));
      }
    } else {
      if (payload?.toDestroy) {
        toastNotification(toasterFlags.ERROR, data?.response?.data?.failure);
      } else {
        yield put(setCatalogEditError(data));
      }
    }
  } catch (error) {
    if (payload?.toDestroy) {
      toastNotification(toasterFlags.ERROR, error);
    } else {
      yield put(setCatalogEditError(error));
    }
  }
}

function* catalogCsvUploadRequestFunction({ data }) {
  try {
    const catalogUploadData = yield call(catalogBulkUploadApi, data);
    if (
      catalogUploadData?.status === statusCode.Ok200 ||
      catalogUploadData?.status === statusCode?.Created201
    ) {
      yield put(catalogueBulkUploadSuccess(catalogUploadData));
      yield put(commonLoaderSuccess());
      yield put(catalogueBulkUploadError(""));
    } else {
      yield put(catalogueBulkUploadError(catalogUploadData));
      yield put(commonLoaderSuccess());
    }
  } catch (error) {
    yield put(catalogueBulkUploadError(error));
    yield put(commonLoaderSuccess());
  }
}

export function* removeSkuFunction({ payload }) {
  try {
    const data = yield call(removeSkuApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(removeSkuSuccess(data));
    } else {
      yield put(removeSkuError(data));
    }
  } catch (err) {
    yield put(removeSkuError(err));
  }
}

export function* addSkuFunction({ payload }) {
  try {
    const data = yield call(addSkuApi, payload);
    if (data?.status === statusCode?.Ok200) {
      yield put(addSkuSuccess(data));
    } else {
      yield put(addSkuError(data));
    }
  } catch (err) {
    yield put(addSkuError(err));
  }
}

export function* retireSkuFunction({ payload }) {
  try {
    const data = yield call(retireSkuApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(retireSkuSuccess(data));
    } else {
      yield put(retireSkuError(data));
    }
  } catch (err) {
    yield put(retireSkuError(err));
  }
}
export function* fetchCloudTemplateByIdSaga({ payload }) {
  try {
    setTemplateDetailsLoading(true);
    const data = yield call(getCloudTemplateByIdRequest, payload);
    yield put(setCloudTemplateById(data?.data));
    setTemplateDetailsLoading(false);
  } catch (err) {
    setTemplateDetailsLoading(false);
    yield put(setCloudTemplateByIdError(err));
  }
}

export function* createCloudBatchSaga({ payload }) {
  try {
    yield put(setBatchLoading(true));
    const data = yield call(createCloudBatchRequest, payload);
    if (data?.status === statusCode?.Created201) {
      yield put(createCloudBatchSuccess(data?.data));
      toastNotification(
        toasterFlags.SUCCESS,
        "Operation completed successfully"
      );
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(
        createCloudBatchError((data?.data?.error && data?.data?.message) || {})
      );
    }
    yield put(setBatchLoading(false));
  } catch (err) {
    yield put(createCloudBatchError({}));
    yield put(setBatchLoading(false));
  }
}
export function* createCloudLabSaga({ payload }) {
  try {
    yield put(setLabLoading(true));
    const data = yield call(createCloudLabRequest, payload);
    if (data?.status === statusCode?.Created201) {
      yield put(createCloudLabSuccess(data?.data));
      toastNotification(
        toasterFlags.SUCCESS,
        "Operation completed successfully"
      );
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(
        createCloudLabError((data?.data?.error && data?.data?.message) || {})
      );
    }
    yield put(setLabLoading(false));
  } catch (err) {
    yield put(createCloudLabError({}));
    yield put(setLabLoading(false));
  }
}
export function* editCloudBatchSaga({ payload }) {
  try {
    yield put(setBatchLoading(true));
    const data = yield call(updateCloudBatchRequest, payload);
    if (data?.status === statusCode?.Ok200) {
      yield put(createCloudBatchSuccess(data?.data));
      toastNotification(
        toasterFlags.SUCCESS,
        "Operation completed successfully"
      );
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(
        createCloudBatchError((data?.data?.error && data?.data?.message) || {})
      );
    }
    yield put(setBatchLoading(false));
  } catch (err) {
    yield put(createCloudBatchError({}));
    yield put(setBatchLoading(false));
  }
}
export function* patchCloudBatchSaga({ payload }) {
  try {
    yield put(setBatchLoading(true));
    const data = yield call(patchCloudBatchRequest, payload);
    if (data?.status === statusCode?.Ok200) {
      yield put(createCloudBatchSuccess(data?.data));
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(
        createCloudBatchError((data?.data?.error && data?.data?.message) || {})
      );
    }
    yield put(setBatchLoading(false));
  } catch (err) {
    yield put(createCloudBatchError({}));
    yield put(setBatchLoading(false));
  }
}

export function* deleteCloudBatchSaga({ payload }) {
  try {
    yield put(setBatchLoading(true));
    const data = yield call(deleteCloudBatchRequest, payload?.batch_id);
    if (data?.status === statusCode?.Ok200) {
      yield put(deleteCloudBatchSuccess(data?.data));
      toastNotification(
        toasterFlags.SUCCESS,
        "Operation completed successfully"
      );
      if (payload?.callbackType === "cloud_batches") {
        yield put(getCloudBatches(payload?.urlParams));
      }
    } else {
      toastNotification(toasterFlags?.WARN, errorMessage);
      yield put(deleteCloudBatchError(data));
    }
    yield put(setBatchLoading(false));
  } catch (err) {
    yield put(deleteCloudBatchError(err));
    yield put(setBatchLoading(false));
  }
}

export function* deleteCloudLabSaga({ payload }) {
  try {
    yield put(setBatchLoading(true));
    const data = yield call(deleteCloudLabRequest, payload?.lab_id);
    if (data?.status === statusCode?.Ok200) {
      yield put(deleteCloudBatchSuccess(data?.data));
      toastNotification(
        toasterFlags.SUCCESS,
        "Operation completed successfully"
      );
      if (payload?.callbackType === "cloud_labs") {
        yield put(deleteCloudLabSuccess());
      } else if (payload?.callbackType === "batch_details") {
        yield put(getCloudBatchById(payload?.batch_id));
      }
    } else {
      toastNotification(toasterFlags?.WARN, errorMessage);
      yield put(deleteCloudBatchError(data));
    }
    yield put(setBatchLoading(false));
  } catch (err) {
    yield put(deleteCloudBatchError(err));
    yield put(setBatchLoading(false));
  }
}
export function* createCloudLabExtensionSaga({ payload }) {
  try {
    yield put(setLabLoading(true));
    const data = yield call(createCloudLabExtensionRequest, payload);
    yield put(setLabLoading(false));
    if (data?.status === statusCode?.Created201) {
      toastNotification(toasterFlags?.SUCCESS, "Lab extend successfully");
      yield put(createCloudLabExtensionSuccess(data?.data));
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(
        createCloudLabExtensionError(data?.data?.error && data?.data?.message)
      );
    }
  } catch (err) {
    yield put(createCloudLabExtensionError(err));
    yield put(setLabLoading(false));
  }
}

export function* createCloudBatchExtensionSaga({ payload }) {
  try {
    yield put(setBatchDetailsLoading(true));
    const data = yield call(createCloudBatchExtensionRequest, payload);
    yield put(setBatchDetailsLoading(false));
    if (data?.status === statusCode?.Created201) {
      yield put(createCloudLabExtensionSuccess(data?.data));
      toastNotification(toasterFlags?.SUCCESS, "Extension Added Successfully");
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(
        createCloudLabExtensionError(data?.data?.error && data?.data?.message)
      );
    }
  } catch (err) {
    yield put(createCloudLabExtensionError(err));
    yield put(setBatchDetailsLoading(false));
  }
}

export function* listCloudBatchSaga({ payload }) {
  try {
    yield put(resetCloudBatchList());
    yield put(setBatchLoading(true));
    const data = yield call(listCloudBatchRequest, payload);
    yield put(getCloudBatchesSuccess(data?.data));
    yield put(setBatchLoading(false));
  } catch (err) {
    yield put(setBatchLoading(false));
    yield put(getCloudBatchesError(err));
  }
}

export function* workspaceCloudBatchTenantListSaga({ payload }) {
  try {
    yield put(resetWorkspaceBatchReportForm());
    const data = yield call(workspaceBatchTenantListApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setWorkspacesTenantList(data?.data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.data?.message);
  }
}

export function* workspacesByTenantIdSaga({ payload }) {
  try {
    const data = yield call(workspaceBatchTenantListApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setWorkspacesByTenantIdSuccess(data?.data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.data?.message);
  }
}

export function* generateWorkspaceReportSaga({ payload }) {
  try {
    const data = yield call(generateWorkspaceReportApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(generateWorkspaceReportSuccess(data?.data));
      toastNotification(toasterFlags.SUCCESS, data?.data?.success);
    } else {
      yield put(generateWorkspaceReportError(data?.data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    yield put(generateWorkspaceReportError(err));
    toastNotification(toasterFlags.WARN, err?.data?.message);
  }
}

export function* workspaceCloudBatchReportsListSaga({ payload }) {
  try {
    yield put(resetWorkspaceCloudBatchesReports());
    yield put(setBatchLoading(true));
    const data = yield call(workspaceCloudBatchReportsListApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setWorkspaceCloudBatchesReportsSuccess(data?.data));
    } else {
      yield put(setWorkspaceCloudBatchesReportsError(data?.error));
    }
    yield put(setBatchLoading(false));
  } catch (err) {
    yield put(setWorkspaceCloudBatchesReportsError(err));
    yield put(setBatchLoading(false));
  }
}

export function* listCloudLabSaga({ payload }) {
  try {
    yield put(setLabLoading(true));
    const data = yield call(listCloudLabRequest, payload);
    yield put(getCloudLabSuccess(data?.data));
    yield put(setLabLoading(false));
  } catch (err) {
    yield put(setLabLoading(false));
    yield put(getCloudLabError(err));
  }
}
export function* getCloudBatchByIdSaga({ payload }) {
  try {
    yield put(setBatchDetailsLoading(true));
    const data = yield call(retrieveCloudBatchByIdRequest, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(getCloudBatchByIdSuccess(data?.data));
    } else {
      toastNotification(toasterFlags?.WARN, errorMessage);
      yield put(getCloudBatchByIdError(data?.data));
    }
    yield put(setBatchDetailsLoading(false));
  } catch (err) {
    yield put(setBatchDetailsLoading(false));
    yield put(getCloudBatchByIdError(err));
  }
}
export function* getWorkspaceCloudBatchByIdSaga({ payload }) {
  try {
    yield put(setBatchDetailsLoading(true));
    const data = yield call(retrieveCloudWorkspaceBatchByIdRequest, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(getWorkspaceCloudBatchByIdSuccess(data?.data));
    } else {
      toastNotification(toasterFlags?.WARN, errorMessage);
      yield put(getWorkspaceCloudBatchByIdError(data?.data));
    }
    yield put(setBatchDetailsLoading(false));
  } catch (err) {
    yield put(setBatchDetailsLoading(false));
    yield put(getWorkspaceCloudBatchByIdError(err));
  }
}
export function* getCloudLabByIdSaga({ payload }) {
  try {
    yield put(setLabDetailsLoading(true));
    const data = yield call(getCloudLabByIdRequest, payload);
    if (data?.status === statusCode.Ok200) {
      const res = data?.data;
      const cloud_lab_x =
        res?.cloud_lab_aws || res?.cloud_lab_gcp || res?.cloud_lab_azure;
      yield put(getCloudLabByIdSuccess({ ...res, ...cloud_lab_x }));
    }
    yield put(setLabDetailsLoading(false));
  } catch (err) {
    yield put(setLabDetailsLoading(false));
    yield put(getCloudLabByIdError(err));
  }
}

export function* deleteCloudTemplateByIdSaga({ payload }) {
  try {
    const data = yield call(deletePublicCloudTemplateRequest, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(deleteCloudTemplateByIdSuccess(data?.data));
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(deleteCloudTemplateByIdError(data?.data));
    }
  } catch (err) {
    yield put(deleteCloudTemplateByIdError(err));
  }
}

export function* getCloudLinkTenantListSaga({ payload }) {
  try {
    yield put(setLinkTenantListLoading(true));
    const data = yield call(listCloudTemplateTenantRequest, payload);
    if (data?.status === statusCode.Ok200)
      yield put(getLinkTenantListSuccess(data?.data));

    yield put(setLinkTenantListLoading(false));
  } catch (err) {
    yield put(setLinkTenantListLoading(false));
  }
}

export function* createCloudLinkTenantListSaga({ payload }) {
  try {
    yield put(setLinkTenantLoading(true));
    const data = yield call(createCloudTemplateTenantRequest, payload);
    if (data?.status === statusCode.Created201)
      yield put(createLinkedTenantSuccess(data?.data));
    else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(
        createLinkedTenantError(data?.data?.error && data?.data?.message)
      );
    }
    yield put(setLinkTenantLoading(false));
  } catch (err) {
    yield put(setLinkTenantLoading(false));
  }
}

export function* editCloudLinkTenantListSaga({ payload }) {
  try {
    yield put(setLinkTenantLoading(true));
    const data = yield call(updateCloudTemplateTenantRequest, payload);
    if (data?.status === statusCode.Ok200)
      yield put(createLinkedTenantSuccess(data?.data));
    else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(
        createLinkedTenantError(data?.data?.error && data?.data?.message)
      );
    }
    yield put(setLinkTenantLoading(false));
  } catch (err) {
    yield put(setLinkTenantLoading(false));
  }
}

export function* retrieveCloudLinkTenantListSaga({ payload }) {
  try {
    const data = yield call(retrieveByIdCloudTemplateTenantRequest, payload);
    if (data?.status === statusCode.Ok200)
      yield put(retrieveByIdLinkedTenantSuccess(data?.data));
  } catch (err) { }
}

export function* deleteCloudLinkTenantListSaga({ payload }) {
  try {
    yield put(setLinkTenantLoading(true));
    const data = yield call(deleteCloudTemplateTenantRequest, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(deleteLinkedTenantSuccess(data?.data));
      toastNotification(toasterFlags?.SUCCESS, data?.data?.success);
    }
    yield put(setLinkTenantLoading(false));
  } catch (err) {
    yield put(setLinkTenantLoading(false));
  }
}

export function* retrieveCloudLabCredentialSaga({ payload }) {
  try {
    const data = yield call(retrieveCloudLabCredential, payload);
    if (data.status === statusCode.Ok200) {
      yield put(successCloudLabCredential(data));
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(errorCloudLabCredential(data));
    }
  } catch (err) {
    yield put(errorCloudLabCredential(err));
  }
}

export function* cloudLabReProvisionSaga({ payload }) {
  try {
    yield put(setLabLoading(true));
    const data = yield call(cloudLabReProvisionRequest, payload?.id);
    yield put(setLabLoading(false));
    if (data?.status === statusCode?.Created201) {
      toastNotification(
        toasterFlags?.SUCCESS,
        "Lab re-provisioned successfully"
      );
      yield put(setCloudLabReProvisionSuccess(data?.data));
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(
        setCloudLabReProvisionError(data?.data?.error && data?.data?.message)
      );
    }
  } catch (err) {
    yield put(setCloudLabReProvisionError(err));
    yield put(setLabLoading(false));
  }
}

export function* updatePermissionPolicySaga({ id, payload }) {
  try {
    yield put(setLabLoading(true));
    const data = yield call(updatePermissionPolicyRequest, id, payload);
    yield put(setLabLoading(false));
    if (data?.status === statusCode?.Ok200) {
      toastNotification(toasterFlags?.SUCCESS, data?.data?.message);
      yield put(setUpdatePermissionPolicySuccess(data?.data));
    } else {
      toastNotification(toasterFlags?.WARN, data?.data?.message);
      yield put(
        setUpdatePermissionPolicyError(data?.data?.error && data?.data?.message)
      );
    }
  } catch (err) {
    yield put(setUpdatePermissionPolicyError(err));
    yield put(setLabLoading(false));
  }
}

export function* azureReportDownloadSaga({ payload }) {
  try {
    yield put(azureReportDownloadLoading(true));
    const data = yield call(azureReportDownloadApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(azureReportDownloadSuccess(data?.data));
    } else {
      // toastNotification(
      //   toasterFlags.ERROR,
      //   data && (data?.data?.message || data?.data)
      // );
      yield put(azureReportDownloadError(data?.data));
    }
    yield put(azureReportDownloadLoading(false));
  } catch (err) {
    yield put(azureReportDownloadError(err));
  }
}

export function* cleanUpAzureSaga({ payload }) {
  try {
    yield put(cleanUpAzureLoading(true));
    const data = yield call(cleanUpAzureApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(cleanUpAzureSuccess(data?.data));
    } else {
      // toastNotification(
      //   toasterFlags.ERROR,
      //   data && (data?.data?.message || data?.data)
      // );
      yield put(cleanUpAzureError(data?.data));
    }
    yield put(cleanUpAzureLoading(false));
  } catch (err) {
    yield put(cleanUpAzureError(err));
  }
}

export function* syncBillSaga({ payload }) {
  try {
    yield put(setLabLoading(true));
    const data = yield call(syncBillApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(syncBillSuccess(data?.data));
      toastNotification(toasterFlags.SUCCESS, "Synced successfully");
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(syncBillError(data?.data));
    }
    yield put(setLabLoading(false));
  } catch (err) {
    yield put(setLabLoading(false));
    yield put(syncBillError(err));
  }
}

export function* awsCleanupSaga({ payload }) {
  try {
    yield put(aws_cleanup_loading(true));
    const data = yield call(awsCleanupApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(aws_cleanup_success(data?.data));
      toastNotification(toasterFlags.SUCCESS, data?.data?.message || "AWS Cleanup successfully");
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(aws_cleanup_error(data?.data));
    }
    yield put(aws_cleanup_loading(false));
  } catch (err) {
    yield put(aws_cleanup_loading(false));
    yield put(aws_cleanup_error(err));
  }
}

export function* getMentorListSaga({ payload }) {
  try {
    const data = yield call(getMentorListApi, payload);
    if (data?.status === statusCode.Ok200 || data?.status === statusCode.Created201) {
      yield put(getMentorListSuccess(data?.data));
    } else {
      // toastNotification(toasterFlags.WARN, data?.data?.message || "Failed to get mentors");
      yield put(getMentorListFail(data?.data));
    }
  } catch (err) {
    yield put(getMentorListFail(err));
  }
}

export function* machineCatalogueRootSaga() {
  yield takeLatest(
    machineCatalogueActions.SKUSLISTGETDATA,
    fetchSkusListFunction
  );
  yield takeLatest(
    machineCatalogueActions.CREATE_CATALOG_REQUEST,
    createCatalogFunction
  );
  yield takeLatest(
    machineCatalogueActions.EDIT_CATALOG_REQUEST,
    editCatalogFunction
  );
  yield takeLatest(
    machineCatalogueActions.CATALOG_BULK_UPLOAD_REQUEST,
    catalogCsvUploadRequestFunction
  );
  yield takeLatest(
    machineCatalogueActions.REMOVE_SKU_REQUEST,
    removeSkuFunction
  );
  yield takeLatest(machineCatalogueActions.ADD_SKU_REQUEST, addSkuFunction);
  yield takeLatest(
    machineCatalogueActions.RETIRE_SKU_REQUEST,
    retireSkuFunction
  );
  yield takeLatest(
    machineCatalogueActions.FETCH_CLOUD_TEMPLATE_BY_ID,
    fetchCloudTemplateByIdSaga
  );
  yield takeLatest(
    machineCatalogueActions.CREATE_CLOUD_BATCH,
    createCloudBatchSaga
  );
  yield takeLatest(
    machineCatalogueActions.EDIT_CLOUD_BATCH,
    editCloudBatchSaga
  );
  yield takeLatest(
    machineCatalogueActions.PATCH_CLOUD_BATCH,
    patchCloudBatchSaga
  );
  yield takeLatest(
    machineCatalogueActions.DELETE_CLOUD_BATCH,
    deleteCloudBatchSaga
  );
  yield takeLatest(
    machineCatalogueActions.DELETE_CLOUD_LAB,
    deleteCloudLabSaga
  );
  yield takeLatest(
    machineCatalogueActions.LIST_CLOUD_BATCH,
    listCloudBatchSaga
  );
  yield takeLatest(
    machineCatalogueActions.GET_WORKSPACE_BATCH_REPORTS_LIST,
    workspaceCloudBatchReportsListSaga
  );
  yield takeLatest(machineCatalogueActions.LIST_CLOUD_LAB, listCloudLabSaga);
  yield takeLatest(
    machineCatalogueActions.CREATE_CLOUD_LAB_EXTENISION,
    createCloudLabExtensionSaga
  );
  yield takeLatest(
    machineCatalogueActions.CREATE_CLOUD_BATCH_EXTENISION,
    createCloudBatchExtensionSaga
  );
  yield takeLatest(
    machineCatalogueActions.FETCH_CLOUD_BATCH_BY_ID,
    getCloudBatchByIdSaga
  );
  yield takeLatest(
    machineCatalogueActions.FETCH_CLOUD_BATCH_BY_ID,
    getWorkspaceCloudBatchByIdSaga
  );
  yield takeLatest(
    machineCatalogueActions.FETCH_CLOUD_LAB_BY_ID,
    getCloudLabByIdSaga
  );
  yield takeLatest(
    machineCatalogueActions.CREATE_CLOUD_LAB,
    createCloudLabSaga
  );
  yield takeLatest(
    machineCatalogueActions.DELETE_CLOUD_TEMPLATE,
    deleteCloudTemplateByIdSaga
  );
  yield takeLatest(
    machineCatalogueActions.LIST_LINK_TENANT,
    getCloudLinkTenantListSaga
  );
  yield takeLatest(
    machineCatalogueActions.CREATE_LINK_TENANT,
    createCloudLinkTenantListSaga
  );
  yield takeLatest(
    machineCatalogueActions.EDIT_LINK_TENANT,
    editCloudLinkTenantListSaga
  );
  yield takeLatest(
    machineCatalogueActions.DELETE_LINK_TENANT,
    deleteCloudLinkTenantListSaga
  );
  yield takeLatest(
    machineCatalogueActions.RETRIEVE_BY_ID_LINK_TENANT,
    retrieveCloudLinkTenantListSaga
  );
  yield takeLatest(
    machineCatalogueActions.REQUEST_CLOUD_LAB_CREDENTIAL,
    retrieveCloudLabCredentialSaga
  );
  yield takeLatest(
    machineCatalogueActions.CLOUD_LAB_RE_PROVISION,
    cloudLabReProvisionSaga
  );
  yield takeLatest(
    machineCatalogueActions.UPDATE_PERMISSION_POLICY,
    updatePermissionPolicySaga
  );
  yield takeLatest(
    machineCatalogueActions.GET_WORKSPACE_TENANT_LIST,
    workspaceCloudBatchTenantListSaga
  );
  yield takeLatest(
    machineCatalogueActions.GET_WORKSPACES_LIST,
    workspacesByTenantIdSaga
  );
  yield takeLatest(
    machineCatalogueActions.GENERATE_WORKSPACE_BATCH_REPORT,
    generateWorkspaceReportSaga
  );
  yield takeLatest(
    machineCatalogueActions.AZURE_REPORT_DOWNLOAD_ACTION,
    azureReportDownloadSaga
  );
  yield takeLatest(
    machineCatalogueActions.CLEAN_UP_AZURE_ACTION,
    cleanUpAzureSaga
  );
  yield takeLatest(
    machineCatalogueActions.SYNC_BILL_ACTION,
    syncBillSaga
  );
  yield takeLatest(
    machineCatalogueActions.AWS_CLEANUP_ACTION,
    awsCleanupSaga
  );
  yield takeLatest(
    machineCatalogueActions.GET_MENTOR_LIST,
    getMentorListSaga
  );
}

export default function* rootSaga() {
  yield all([fork(machineCatalogueRootSaga)]);
}
